import type { PureGraphEdge } from '@ardoq/graph';
import type { GraphEdgesToRelationshipsLinksReducerState } from 'tabview/relationshipDiagrams/types';
import { createLink } from './createLink';

/**
 * Creates edges amd mutates state.links (for performance reasons)
 */
const reduceLinks = (
  state: GraphEdgesToRelationshipsLinksReducerState,
  graphEdge: PureGraphEdge
): GraphEdgesToRelationshipsLinksReducerState => {
  state.links.push(
    createLink({
      graphEdge,
      nodeMap: state.nodeMap,
      referenceType:
        state.allEdgesReferenceTypes.get(graphEdge.modelId) ?? null,
      linksBySourceAndTarget: state.linksBySourceAndTarget,
      colorFilterIdsByReferenceId: state.colorFilterIdsByReferenceId,
    })
  );
  return state;
};

export { reduceLinks };
